import type { FileContent } from '@shared/components/FilePreview';
import { base64ToBlob } from '@shared/util/base64ToBlob';

import { useQueryMutation } from './useQueryMutation';

const AI_SUMMARIZE_URL = 'ai-services/v1/summarize/pdf';

export type AiSummaryResponse = {
    summary: string;
    source_chars: number;
};

const createPdfFormData = (file: FileContent) => {
    const content = file.content.includes(',')
        ? (file.content.split(',').at(-1) ?? '')
        : file.content;
    const pdf = base64ToBlob(content, 'application/pdf');
    const formData = new FormData();

    formData.set(
        'file',
        new File([pdf], file.name || 'document.pdf', {
            type: 'application/pdf',
        }),
    );

    return formData;
};

export const usePdfAiAnalysis = () => {
    const summarizePdf = useQueryMutation<FormData, AiSummaryResponse>(
        AI_SUMMARIZE_URL,
        'post',
        {
            hideSuccessNotification: true,
            variablesOption: (_url, formData, axiosConfig) => ({
                body: formData,
                axiosConfig: {
                    ...axiosConfig,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                },
            }),
        },
    );

    return {
        analyzePdf: (file: FileContent) =>
            summarizePdf.mutateAsync(createPdfFormData(file)),
        isPending: summarizePdf.isPending,
    };
};
